import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Stories, StoryData } from 'storyblok-js-client';
import { StoryblokService } from './storyblok.service';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { StoryblokGlobalContent } from '../models/storyblok-global-content.model';

@Injectable({
  providedIn: 'root',
})
export class StoryblokGlobalContentService {
  constructor(private storyblokService: StoryblokService) {}

  public getGlobalContent(): Observable<StoryblokGlobalContent> {
    const market = MarketDetectionUtil.getCountryCode()
    const sbParams = { starts_with: `${market}/global` };
    return from(this.storyblokService.getStories(sbParams)).pipe(
      map((response) => this.parseGlobalContentResponse(response) || null)
    );
  }

  private parseGlobalContentResponse(response: Stories): StoryblokGlobalContent {
    let globalContent: StoryblokGlobalContent;
    response.data['stories'].forEach((story: StoryData) => {
      globalContent = { ...globalContent, ...{ [story.slug]: story } };
    });

    return globalContent;
  }
}
